import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	isActive: false,
	isFirstTime: true, // Persisted via redux-persist. Override for testing via ?first-time.
	currentCueIndex: 0,
	waitingFor: null,
	highlightedElement: null,
	highlightShape: 'rect',
	cutoutPadding: 0,
	borderRadius: 0,
	cutoutBorder: false,
	message: '',
	messages: null, // Optional array of messages for rotation
	arrowDirection: null,
	skipEnabled: true,
	allowInteraction: false, // Whether cutout allows clicks to pass through
}

const tutorialSlice = createSlice({
	name: 'tutorial',
	initialState,
	reducers: {
		startTutorial: state => {
			state.isActive = true
			state.currentCueIndex = 0
			state.waitingFor = null
			state.highlightedElement = null
			state.highlightShape = 'rect'
			state.message = ''
			state.arrowDirection = null
		},
		nextCue: state => {
			state.currentCueIndex++
			state.waitingFor = null
			state.highlightedElement = null
			state.highlightShape = 'rect'
			state.cutoutPadding = 0
			state.borderRadius = 0
			state.cutoutBorder = false
			state.arrowDirection = null
			state.allowInteraction = false
			state.messages = null
		},
		skipTutorial: state => {
			state.isActive = false
			state.currentCueIndex = 0
			state.waitingFor = null
			state.highlightedElement = null
			state.highlightShape = 'rect'
			state.message = ''
			state.messages = null
			state.arrowDirection = null
			state.isFirstTime = false
		},
		completeTutorial: state => {
			state.isActive = false
			state.currentCueIndex = 0
			state.waitingFor = null
			state.highlightedElement = null
			state.highlightShape = 'rect'
			state.message = ''
			state.messages = null
			state.arrowDirection = null
			state.isFirstTime = false
		},
		setWaitingFor: (state, action) => {
			state.waitingFor = action.payload
		},
		setHighlightedElement: (state, action) => {
			state.highlightedElement = action.payload
		},
		setMessage: (state, action) => {
			state.message = action.payload
		},
		setHighlightShape: (state, action) => {
			state.highlightShape = action.payload
		},
		setArrowDirection: (state, action) => {
			state.arrowDirection = action.payload
		},
		setCue: (state, action) => {
			// Generic reducer to merge any cue properties
			Object.assign(state, action.payload)
		},
	},
})

export const {
	startTutorial,
	nextCue,
	skipTutorial,
	completeTutorial,
	setWaitingFor,
	setHighlightedElement,
	setMessage,
	setHighlightShape,
	setArrowDirection,
	setCue,
} = tutorialSlice.actions

export default tutorialSlice.reducer
